import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import {
  SvgIcon,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { mdiContentSave, mdiDeleteForever } from '@mdi/js'

import UserNameContainer from './UserNameContainer'

const DEFAULT_STATE = {
  email: '',
  roleId: '',
}

class OrganizationUserList extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  }

  static styles = (theme) => ({
    paper: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      marginTop: theme.spacing(3),
    }),
    textField: {
      width: '100%',
    },
  })

  state = DEFAULT_STATE

  handleSaveClick = () => {
    const { email, roleId } = this.state

    this.props.onAdd({
      organizationId: this.props.organization.id,
      email,
      roleId,
    })
    this.setState(DEFAULT_STATE)
  }

  handleRemoveClick = (userId) => {
    const users = this.props.organization.users.filter((user) => user.user_id !== userId)
    const organization = {
      id: this.props.organization.id,
      users,
    }
    this.props.onRemove(organization)
  }

  handleEmailChange = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  handleRoleIdChange = (e) => {
    this.setState({
      roleId: e.target.value,
    })
  }

  render() {
    const { organization, roles, classes } = this.props
    const { email, roleId } = this.state

    const addUserHtml = (
      <TableRow key="new">
        <TableCell>
          <TextField
            className={classes.textField}
            label="Email Address"
            name="email"
            onChange={this.handleEmailChange}
            required
            value={email}
          />
        </TableCell>
        <TableCell>
          <Select value={roleId} autoWidth onChange={this.handleRoleIdChange}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {Object.values(roles).map((role) => (
              <MenuItem key={role.id} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </TableCell>
        <TableCell>
          <IconButton aria-label="Save" onClick={this.handleSaveClick}>
            <SvgIcon>
              <path d={mdiContentSave} />
            </SvgIcon>
          </IconButton>
        </TableCell>
      </TableRow>
    )

    const users = organization.users || []
    return (
      <Paper className={classes.paper} elevation={0}>
        <Typography variant="h6">{`Organization: ${organization.name} Users`}</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Role</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {addUserHtml}
            {
              users.map((u) => (
                <TableRow key={u.user_id}>
                  <TableCell><UserNameContainer userId={u.user_id} /></TableCell>
                  <TableCell>{(roles[u.role_id] || { name: '' }).name}</TableCell>
                  <TableCell>
                    <IconButton aria-label="Remove" onClick={() => this.handleRemoveClick(u.user_id)}>
                      <SvgIcon>
                        <path d={mdiDeleteForever} />
                      </SvgIcon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(OrganizationUserList.styles)(OrganizationUserList)
